/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { showAllCards, deleteCard } from 'js/actions/cardAction';
import { Link } from 'react-router-dom';

import { Box, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';

import styles from './styles';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
const useStyles = makeStyles(styles);

function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        justifyContent: 'flex-end', // Alinea el filtro a la derecha
      }}
    >
      <GridToolbarQuickFilter /> {/* Barra de búsqueda rápida para la tabla */}
    </Box>
  );
}

export default function AllCardsTable() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const cards = useSelector((state) => state.cards.cards);
  const user = useSelector((state) => state.user.user);

  const corpAdmin = useSelector((state) => state.user.corporative);
  const corpUser = user.corporative;
  const corporativeId =
    corpUser === undefined || corpUser === null ? corpAdmin.id : corpUser.id;

  const meterAdmin = useSelector((state) => state.user.meter);
  const meterUser = user.meters;
  const meterId =
    meterUser === undefined || meterUser === null ? meterAdmin : meterUser.id;

  const [state, setState] = useState({
    columns: [
      { headerName: 'Identificador', field: 'id', flex: 1 },
      { headerName: 'Nombre', field: 'name', flex: 1 },
      { headerName: 'Tipo', field: 'type', flex: 1 },
      { headerName: 'Direccion MAC', field: 'mac_address', flex: 1 },
      {
        headerName: 'Alta Tarjetas de Control',
        flex: 1,
        field: '',
        renderCell: (rowData) => (
          <Link
            className={classes.iconTable}
            to={`/newControlCard/${rowData.row.concentrator_id}/${rowData.row.id}`}
          >
            <Button color="secondary" variant="contained">
              {' '}
              Crear Tarjeta de Control
            </Button>
          </Link>
        ),
      },
      {
        headerName: 'Tarjetas de Control',
        flex: 1,
        renderCell: (rowData) => (
          <Link
            className={classes.iconTable}
            to={`/controlCards/${rowData.row.id}`}
            state={{ card: rowData.row }}
          >
            <Button color="secondary" variant="outlined">
              {' '}
              Ver Tarjetas de Control
            </Button>
          </Link>
        ),
      },
    ],
  });

  const deleteCardData = (cardId) => {
    dispatch(deleteCard(cardId));
  };

  useEffect(() => {
    dispatch(showAllCards(corporativeId, meterAdmin));
  }, []);

  useEffect(() => {
    setState({ ...state, data: cards });
  }, [cards]);

  return (
    <Box height={500} width="100%">
      <DataGrid
        rows={state.data}
        columns={state.columns}
        // Deshabilitar la seleccion de filas
        rowSelection={false}
        // Configuración de tabla
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5, // Tamaño de la página
            },
          },
        }}
        slots={{ toolbar: QuickSearchToolbar }} // Usa el componente QuickSearchToolbar para la barra de búsqueda
        sx={{
          pt: 2,
          pb: 2,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: 'background.paper', // Color de fondo de la tabla
          border: '1px solid',
          borderColor: 'divider',
          '& .MuiDataGrid-root': {
            border: 'none', // Quitar borde de la tabla
          },
          '& .MuiDataGrid-cell': {
            borderBottom: '1px solid rgba(224, 224, 224, 1)', // Borde inferior de las celdas
            maxHeight: '60px', // Altura máxima de las celdas
          },
          '& .MuiDataGrid-columnHeaders': {
            borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de los encabezados de columna
          },
          '& .MuiDataGrid-row': {
            borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de las filas
            maxHeight: '60px', // Altura máxima de las filas
          },
        }}
      />
    </Box>
  );
}
